import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditHighlightsForm } from '../../../components/cv/forms/EditHighlightsForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useUpsertHighlight, useDeleteHighlight } from '../../../hooks/useProfileApi';
import { mapHighlightToAPI } from '../../../lib/cv-mapping';
import { assertCvItemBatchSaved } from '../../../lib/cv-write-coordinator';

export default function EditHighlightsWebScreen() {
  const { t } = useTranslation('seeker');
  const { profile, profileRef } = useCVData();
  const upsertHL = useUpsertHighlight();
  const deleteHL = useDeleteHighlight();
  const initialIdsRef = useRef(new Set(profile.highlights.filter((h: any) => h.id).map((h: any) => h.id)));

  const handleSave = async () => {
    const items = profileRef.current.highlights;
    const currentIds = new Set(items.filter((h: any) => h.id).map((h: any) => h.id));
    const removedIds = [...initialIdsRef.current].filter((id) => !currentIds.has(id));
    const results = await Promise.allSettled([
      ...items.map((hl, i) => upsertHL.mutateAsync(mapHighlightToAPI(hl, i))),
      ...removedIds.map((id) => deleteHL.mutateAsync(id)),
    ]);
    // One save, one answer: a CV conflict choice (B02) is reported as such;
    // otherwise only a save where every item failed is a failure.
    assertCvItemBatchSaved(results);
  };

  return (
    <WebEditPageShell title={t('cv.edit.highlights')}>
      <EditHighlightsForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
